import { put, call, takeLatest } from "redux-saga/effects";
import * as Actions from "us.collection.debtor/actions";
import * as API from "us.collection.debtor/services";
import { DuplicateDebtors } from "us.collection.debtor/constants/Actions";
import { formatDuplicateDebtors } from "us.collection.debtor/functions";
import _ from "lodash";
import { $MessageBox } from "us.common/components";
import { domainViewAction } from "us.collection/actions";

const { duplicateDebtors } = Actions;
const { metaData } = domainViewAction;
const { search, merge, getHistory } = API.duplicateDebtors;
const { debtors, mergeDebtors, debtorHistory } = duplicateDebtors;
const {
  SEARCH_DUPLICATING_DEBTORS,
  MERGE_DUPLICATE_DEBTORS,
  GET_DUPLICATE_DEBTORS_HISTORY,
} = DuplicateDebtors;

export const DuplicateDebtorsSagas = {
  duplicateDebtors: {
    search: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const { data, status } = yield call(search, params);
        if (Array.isArray(data) && status === 200) {
          yield put(
            debtors.success(formatDuplicateDebtors(data, params?.debtorId))
          );
        } else {
          yield put(debtors.fail(new Error()));
        }
      } catch (error) {
        yield put(debtors.fail(new Error()));
      }
    },
    merge: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      const { caseId, debtorId, isOtherDebtorRetained } = params ?? {};
      try {
        const { data, status } = yield call(merge, params?.saveParams);
        if (status === 200) {
          if (metaData.get && isOtherDebtorRetained) {
            yield put(
              metaData.get({
                id: caseId,
                type: "caseid",
              })
            );
          }
          const { data: debtorData, status: debtorStatus } = yield call(
            search,
            { debtorId }
          );
          if (Array.isArray(debtorData) && debtorStatus === 200) {
            yield put(
              debtors.success(formatDuplicateDebtors(debtorData, debtorId))
            );
          } else {
            yield put(debtors.fail(new Error()));
          }
          $MessageBox(
            "success",
            "US.COLLECTION.DEBTOR:DUPLICATE_DEBTORS.SUCCESSFULLY_MERGED",
            "",
            ""
          );
          yield put(mergeDebtors.success(data));
        } else if(status === 403){
          $MessageBox(
            "info",
            "US.COLLECTION.DEBTOR:DUPLICATE_DEBTORS.FEATURE_NOT_AVAILABLE",
            "",
            ""
          );
          yield put(mergeDebtors.fail(new Error()));
        } else {
          yield put(mergeDebtors.fail(new Error()));
        }
      } catch (error) {
        yield put(mergeDebtors.fail(new Error()));
      }
    },
    getHistory: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const { data, status } = yield call(getHistory, params);
        if (Array.isArray(data) && status === 200) {
          yield put(debtorHistory.success(data));
        } else if(status === 403){
          $MessageBox(
            "info",
            "US.COLLECTION.DEBTOR:DUPLICATE_DEBTORS.FEATURE_NOT_AVAILABLE",
            "",
            ""
          );
          yield put(debtorHistory.fail(new Error()));
        } else {
          yield put(debtorHistory.fail(new Error()));
        }
      } catch (error) {
        yield put(debtorHistory.fail(new Error()));
      }
    },
  },
};

export default [
  takeLatest(
    SEARCH_DUPLICATING_DEBTORS,
    DuplicateDebtorsSagas.duplicateDebtors.search
  ),
  takeLatest(
    MERGE_DUPLICATE_DEBTORS,
    DuplicateDebtorsSagas.duplicateDebtors.merge
  ),
  takeLatest(
    GET_DUPLICATE_DEBTORS_HISTORY,
    DuplicateDebtorsSagas.duplicateDebtors.getHistory
  ),
];
